import React from 'react';

const Sidebar = ({ sidebarOpen, setSidebarOpen, navigation, activeView, setActiveView, user, handleLogout }) => {
  return (
    <>
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 flex z-40 md:hidden">
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
          ></div>
          <div className="relative flex-1 flex flex-col max-w-xs w-full bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 shadow-2xl">
            <div className="absolute top-4 right-4 z-50">
              <button
                type="button"
                className="flex items-center justify-center h-8 w-8 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white/50"
                onClick={() => setSidebarOpen(false)}
              >
                <span className="sr-only">Close sidebar</span>
                <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
              <div className="flex-shrink-0 flex items-center px-4 mb-8">
                <div className="h-10 w-10 bg-gradient-to-br from-purple-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-lg">G</span>
                </div>
                <div className="ml-3">
                  <span className="text-white font-bold text-lg">GestyAdmin</span>
                  <div className="text-purple-300 text-xs">Management Panel</div>
                </div>
              </div>
              <nav className="mt-5 px-2 space-y-1">
                {navigation.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      setActiveView(item.view);
                      setSidebarOpen(false); // Close sidebar on mobile after clicking
                    }}
                    className={`${
                      item.current
                        ? 'bg-purple-600 text-white shadow-md'
                        : 'text-slate-300 hover:bg-white/10 hover:text-white hover:transform hover:scale-105'
                    } group flex items-center px-3 py-2 text-base font-medium rounded-lg w-full text-left transition-all duration-200 ease-in-out backdrop-blur-sm border border-transparent hover:border-white/20`}
                  >
                    <span className="mr-3 text-xl flex-shrink-0">
                      <item.icon className="h-6 w-6" />
                    </span>
                    <span className="truncate">{item.name}</span>
                    {item.current && (
                      <div className="ml-auto w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                    )}
                  </button>
                ))}
              </nav>
            </div>
            
            {/* Mobile logout section */}
            <div className="flex-shrink-0 border-t border-slate-700 p-4">
              <div className="flex items-center mb-3">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-white truncate">{user?.email}</p>
                  <p className="text-xs text-slate-400">Administrator</p>
                </div>
              </div>
              <button
                onClick={handleLogout}
                className="w-full bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm font-medium transition duration-150 ease-in-out flex items-center justify-center"
              >
                <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Sign out
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Desktop sidebar */}
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
        <div className="flex-1 flex flex-col min-h-0 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 shadow-2xl border-r border-slate-700">
          <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <div className="flex items-center flex-shrink-0 px-4 mb-8">
              <div className="h-10 w-10 bg-gradient-to-br from-purple-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-lg">G</span>
              </div>
              <div className="ml-3">
                <span className="text-white font-bold text-lg">GestyAdmin</span>
                <div className="text-purple-300 text-xs">Management Panel</div>
              </div>
            </div>
            <nav className="mt-5 flex-1 px-2 space-y-1">
              {navigation.map((item) => (
                <button
                  key={item.name}
                  onClick={() => setActiveView(item.view)}
                  className={`${
                    item.current
                      ? 'bg-purple-600 text-white shadow-md'
                      : 'text-slate-300 hover:bg-white/10 hover:text-white hover:transform hover:scale-105'
                  } group flex items-center px-3 py-2 text-sm font-medium rounded-lg w-full text-left transition-all duration-200 ease-in-out backdrop-blur-sm border border-transparent hover:border-white/20`}
                >
                  <span className="mr-3 text-xl flex-shrink-0">
                    <item.icon className="h-6 w-6" />
                  </span>
                  <span className="truncate">{item.name}</span>
                  {item.current && (
                    <div className="ml-auto w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                  )}
                </button>
              ))}
            </nav>
          </div>
          
          {/* Desktop logout section */}
          <div className="flex-shrink-0 border-t border-slate-700 p-4">
            <div className="flex items-center mb-3">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate">{user?.email}</p>
                <p className="text-xs text-slate-400">Administrator</p>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="w-full bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm font-medium transition duration-150 ease-in-out flex items-center justify-center"
            >
              <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Sign out
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
